import React from "react";
import { X } from "lucide-react";

export function ActiveFilterChips({ filters, onClear, onClearAll }) {
  const chips = [];
  if (filters.selectedDepartment !== "ALL") chips.push({ key: "dept", label: filters.selectedDepartment });
  if (filters.selectedEmployeeStatus !== "ALL") chips.push({ key: "status", label: filters.selectedEmployeeStatus });
  if (!chips.length) return null;

  return (
    <div className="flex items-center gap-2 px-6 lg:px-8 -mt-2 mb-4 flex-wrap">
      <span className="text-xs text-slate-400 font-medium">Filtered by:</span>
      {chips.map((c) => (
        <span
          key={c.key}
          className="flex items-center gap-1.5 bg-blue-50 text-blue-700 text-xs font-semibold rounded-full pl-3 pr-1.5 py-1"
        >
          {c.label}
          <button
            onClick={() => onClear(c.key)}
            className="w-4 h-4 rounded-full hover:bg-blue-100 flex items-center justify-center"
          >
            <X size={11} />
          </button>
        </span>
      ))}
      <button onClick={onClearAll} className="text-xs font-semibold text-slate-400 hover:text-slate-600 ml-1">
        Clear all
      </button>
    </div>
  );
}